import React, {useEffect} from 'react';
import {AuthService} from "../service/AuthService";
import {isAdmin, toTitleCase} from "./Utils";
import {AppContext} from "../HomePage";


const ErrorHandler = (props) => {

    const {t, toast} = React.useContext(AppContext);

    useEffect ( ()=>{
        if (props.error)
            handleError(props.error);
    }, [props.error]);

    // axios aborts its own `timeout` with ECONNABORTED (ETIMEDOUT on some
    // adapters). Anything else that never received a response is a transport
    // failure, not a timeout.
    const isTimeout = (error) =>
        error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT';

    const blobToData = (blob) => {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.readAsText(blob)
        })
    }

    const handleError = async (error) =>
    {
        let summary = "", detail = "", more_detail = "";
        if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */

            if(error.response.status === 401){
                AuthService.logout();
                window.location = '#/login?expire=1';
                return;
            }
            summary = error.response.status ? t('api.summary.'+error.response.status) : "";
            // Prefer the error_key translation, but when no translation exists
            // (i18next then returns the key itself) fall back to the backend's
            // human-readable `error` message instead of showing the raw key.
            const detailFromData = (data) => {
                if (data.error_key) {
                    const translated = t(data.error_key);
                    if (translated !== data.error_key) return translated;
                }
                return data.error ?? data.detail ??
                    (error.response.status ? t('api.detail.'+error.response.status) : "");
            };
            if (error.response.data instanceof Blob)
                detail = detailFromData(JSON.parse(await blobToData(error.response.data)));
            else
                detail = detailFromData(error.response.data);
        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             *
             * Only a real client timeout may be reported as one. A reset
             * connection, a dead network and an error response the browser
             * refused to expose (the ingress omits CORS headers on the 4xx/5xx
             * it generates itself) all land here too, and calling those a
             * "timeout" has twice sent debugging after slow queries that were
             * never the cause.
             */
            const key = isTimeout(error) ? '408'
                : (navigator.onLine === false ? 'offline' : 'network');
            summary = t('api.summary.' + key);
            detail = t('api.detail.' + key);
        } else {
            // Something happened in setting up the request and triggered an Error
            summary = t('api.summary.500');
            detail = t('api.detail.500');
        }
        more_detail = error

        // `summary` is a short label, so title casing it is harmless. `detail`
        // is a full sentence that the translations already punctuate, and title
        // casing mangles it -- including Turkish, where "i".toUpperCase() is a
        // dotless "I" ("için" came out as "Için").
        summary = summary ? toTitleCase(summary) : "";
        detail = detail || "";

        toast.current.show({severity: "error", summary: summary, detail: detail + (isAdmin() ? more_detail : "")});
    };

    return "";
};
export default ErrorHandler;
